import Vue from 'vue'
import Vuex from 'vuex'
import { DEFAULT_PLAN_KEY, canPlanAccessModule, canPlanAccessModuleItem, getBusinessPlanKey } from '@/constants/pricingPlans'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: null,
    navFullSize: true,
    kioskMode: false,
    business: {
      free_trials: 0,
      currency: 'dh',
      licence: '',
      language: 'fr',
      metadata: {
        "references": {
          "devis": "DEVIS-00{{ID}}-{{MONTH}}-{{DAY}}-{{YEAR}}",
          "delivery": "DEL-00{{ID}}-{{MONTH}}-{{DAY}}-{{YEAR}}",
          "invoice": "INVOICE-00{{ID}}-{{MONTH}}-{{DAY}}-{{YEAR}}",
          "process": "BP-00{{ID}}-{{MONTH}}-{{DAY}}-{{YEAR}}",
          "credit_note": "INVOICE-00{{ID}}-{{MONTH}}-{{DAY}}-{{YEAR}}",
          "order": "ORDER-00{{ID}}-{{MONTH}}-{{DAY}}-{{YEAR}}",
          "purchase": "PURCHASE-00{{ID}}-{{MONTH}}-{{DAY}}-{{YEAR}}",
          "reception": "RECEPTION-00{{ID}}-{{MONTH}}-{{DAY}}-{{YEAR}}",
          "payment": "PAYMENT-00{{ID}}-{{MONTH}}-{{DAY}}-{{YEAR}}",
          "return": "RETURN-00{{ID}}-{{MONTH}}-{{DAY}}-{{YEAR}}"
        }
      },
      price_includes_tax: true,
      extra_fields: []
    },
    modules: [
      {
        "module_key": "dashboard",
        "description": "dashboard_description",
        "title": "dashboard_title",
        "icon": "bi-speedometer",
        "position": 1,
        "enabled": false,
        "items": [
          {
            "title": "dashboard",
            "icon": "bi-speedometer",
            "link": "/",
            "permission": "view_dashboard",
            "enabled": false,
            "position": 1
          }
        ]
      },
      {
        "module_key": "crm",
        "description": "crm_description",
        "title": "crm_title",
        "icon": "bi-people",
        "position": 2,
        "enabled": false,
        "items": [
          {
            "title": "clients",
            "icon": "bi-people",
            "link": "/clients",
            "permission": "view_clients",
            "enabled": false,
            "position": 1
          },
          {
            "title": "suppliers",
            "icon": "bi-people",
            "link": "/suppliers",
            "permission": "view_suppliers",
            "enabled": false,
            "position": 2
          }
        ]
      },
      {
        "module_key": "inventory",
        "description": "inventory_description",
        "title": "inventory_title",
        "icon": "bi-box2",
        "position": 3,
        "enabled": false,
        "items": [
          {
            "title": "products",
            "icon": "bi-box2",
            "link": "/products",
            "permission": "view_inventories",
            "enabled": false,
            "position": 1
          },
          {
            "title": "categories",
            "icon": "bi-tags",
            "link": "/categories",
            "permission": "view_categories",
            "enabled": false,
            "position": 2
          },
          {
            "title": "warehouses",
            "icon": "bi-house",
            "link": "/warehouses",
            "permission": "view_warehouses",
            "enabled": false,
            "position": 3
          }
        ]
      },
      {
        "module_key": "sales",
        "description": "sales_description",
        "title": "sales_title",
        "icon": "bi-cart4",
        "position": 4,
        "enabled": false,
        "items": [
          {
            "title": "quotes",
            "icon": "bi-receipt",
            "link": "/quotes",
            "permission": "view_quotes",
            "enabled": false,
            "position": 1
          },
          {
            "title": "orders",
            "icon": "bi-cart4",
            "link": "/orders",
            "permission": "view_orders",
            "enabled": false,
            "position": 2
          },
          {
            "title": "deliveries",
            "icon": "bi-truck",
            "link": "/deliveries",
            "permission": "view_deliveries",
            "enabled": false,
            "position": 3
          },
          {
            "title": "invoices",
            "icon": "bi-file-ruled",
            "link": "/invoices",
            "permission": "view_invoices",
            "enabled": false,
            "position": 4
          },
          {
            "title": "processes",
            "icon": "bi-file-earmark-check",
            "link": "/receipts",
            "permission": "view_receipts",
            "enabled": false,
            "position": 5
          },
          {
            "title": "returns",
            "icon": "bi-clipboard-x",
            "link": "/returns",
            "permission": "view_returns",
            "enabled": false,
            "position": 6
          },
          {
            "title": "sales_insights",
            "icon": "bi-graph-up",
            "link": "/sales-insights",
            "permission": "view_invoices",
            "enabled": false,
            "position": 7
          }
        ]
      },
      {
        "module_key": "purchases",
        "description": "purchasing_description",
        "title": "purchasing_title",
        "icon": "bi-cart4",
        "position": 5,
        "enabled": false,
        "items": [
          {
            "title": "purchases",
            "icon": "bi-cart4",
            "link": "/purchases",
            "permission": "view_purchases",
            "enabled": false,
            "position": 1
          },
          {
            "title": "supplier_receptions",
            "icon": "bi-bag-check",
            "link": "/receptions",
            "permission": "view_receptions",
            "enabled": false,
            "position": 2
          },
          {
            "title": "supplier_invoices",
            "icon": "bi-file-ruled",
            "link": "/supplier-invoices",
            "permission": "view_supplier_invoices",
            "enabled": false,
            "position": 3
          },
          {
            "title": "supplier_returns",
            "icon": "bi-clipboard-x",
            "link": "/supplier-returns",
            "permission": "view_supplier_returns",
            "enabled": false,
            "position": 4
          },
          {
            "title": "purchase_insights",
            "icon": "bi-graph-up",
            "link": "/purchase-insights",
            "permission": "view_purchases",
            "enabled": false,
            "position": 5
          }
        ]
      },
      {
        "module_key": "pos",
        "description": "pos_description",
        "title": "pos_title",
        "icon": "bi-basket",
        "position": 6,
        "enabled": false,
        "items": [
          {
            "title": "pos",
            "icon": "bi-basket",
            "link": "/pos",
            "permission": "view_pos",
            "enabled": false,
            "position": 1
          },
          {
            "title": "pos_transactions",
            "icon": "bi-wallet",
            "link": "/pos-transactions",
            "permission": "view_pos_transactions",
            "enabled": false,
            "position": 2
          },
          {
            "title": "pos_cash_registers",
            "icon": "bi-cash-stack",
            "link": "/pos-cash-registers",
            "permission": "view_pos_cash_registers",
            "enabled": false,
            "position": 3
          },
          {
            "title": "pos_insights",
            "icon": "bi-graph-up",
            "link": "/pos-insights",
            "permission": "view_pos_insights",
            "enabled": false,
            "position": 4
          }
        ]
      },
      {
        "module_key": "finance",
        "description": "finance_description",
        "title": "finance_title",
        "icon": "bi-wallet2",
        "position": 7,
        "enabled": false,
        "items": [
          {
            "title": "payments",
            "icon": "bi-wallet2",
            "link": "/payments",
            "permission": "view_payments",
            "enabled": false,
            "position": 1
          },
          {
            "title": "zakat",
            "icon": "bi-calculator",
            "link": "/zakat",
            "permission": "view_payments",
            "enabled": false,
            "position": 2
          },
          // {
          //   "title": "bank_accounts",
          //   "icon": "bi-bank",
          //   "link": "/bank-accounts",
          //   "permission": "view_bank_accounts",
          //   "enabled": false,
          //   "position": 2
          // }
        ]
      },
      {
        "module_key": "attachments",
        "description": "attachments_description",
        "title": "attachments_title",
        "icon": "bi-archive",
        "position": 8,
        "enabled": false,
        "items": [
          {
            "title": "attachments",
            "icon": "bi-archive",
            "link": "/attachments",
            "permission": "view_attachments",
            "enabled": false,
            "position": 1
          }
        ]
      },
      {
        "module_key": "subscription_management",
        "description": "subscription_management_description",
        "title": "subscription_management_title",
        "icon": "bi-journal-check",
        "position": 9,
        "enabled": false,
        "items": [
          {
            "title": "overview",
            "icon": "bi-graph-up",
            "link": "/subscription-overview",
            "permission": "view_subscriptions",
            "enabled": false,
            "position": 1
          },
          {
            "title": "subscriptions",
            "icon": "bi-credit-card",
            "link": "/subscriptions",
            "permission": "view_subscriptions",
            "enabled": false,
            "position": 2
          },
          {
            "title": "plans",
            "icon": "bi-list-check",
            "link": "/plans",
            "permission": "view_plans",
            "enabled": false,
            "position": 3
          },
          {
            "title": "attendance",
            "icon": "bi-calendar-check",
            "link": "/attendance",
            "permission": "view_attendance",
            "enabled": false,
            "position": 4
          },
          // {
          //   "title": "external_attendance",
          //   "icon": "bi-calendar-check",
          //   "link": "/external-attendance",
          //   "permission": "view_attendance",
          //   "enabled": false,
          //   "position": 5
          // }
        ]
      },
      {
        "module_key": "reservations",
        "description": "reservations_description",
        "title": "reservations_title",
        "icon": "bi-calendar-event",
        "position": 10,
        "enabled": false,
        "items": [
          {
            "title": "reservations",
            "icon": "bi-calendar-event",
            "link": "/reservations",
            "permission": "view_reservations",
            "enabled": false,
            "position": 1
          },
          {
            "title": "reservation_insights",
            "icon": "bi-graph-up",
            "link": "/reservation-insights",
            "permission": "view_reservations",
            "enabled": false,
            "position": 2
          }
        ]
      },
      {
        "module_key": "accountant",
        "description": "accountant_description",
        "title": "accountant_title",
        "icon": "bi-person-rolodex",
        "position": 8,
        "enabled": false,
        "items": [
          {
            "title": "accountants",
            "icon": "bi-person-rolodex",
            "link": "/accountants",
            "permission": "view_accountants",
            "enabled": false,
            "position": 1
          }
        ]
      },
      {
        "module_key": "project_management",
        "description": "project_management",
        "title": "project_management",
        "icon": "bi-kanban",
        "position": 8,
        "enabled": false,
        "items": [
          {
            "title": "projects",
            "icon": "bi-kanban",
            "link": "/projects",
            "permission": "view_projects",
            "enabled": false,
            "position": 1
          },
          {
            "title": "tasks",
            "icon": "bi-list-task",
            "link": "/tasks",
            "permission": "view_tasks",
            "enabled": false,
            "position": 1
          }
        ]
      },
      {
        "module_key": "hr",
        "description": "hr_description",
        "title": "hr_title",
        "icon": "bi-person-badge",
        "position": 9,
        "enabled": false,
        "items": [
          {
            "title": "my_space",
            "icon": "bi-person-workspace",
            "link": "/hr/my-space",
            "permission": "view_my_space",
            "enabled": false,
            "position": 0
          },
          {
            "title": "employees",
            "icon": "bi-people",
            "link": "/hr/employees",
            "permission": "view_employees",
            "enabled": false,
            "position": 1
          },
          {
            "title": "employee_leaves",
            "icon": "bi-calendar-check",
            "link": "/hr/leaves",
            "permission": "view_holidays",
            "enabled": false,
            "position": 2
          },
          {
            "title": "attendance_management",
            "icon": "bi-clock-history",
            "link": "/hr/attendance",
            "permission": "view_attendances",
            "enabled": false,
            "position": 3
          },
          {
            "title": "payroll_management",
            "icon": "bi-wallet2",
            "link": "/hr/payroll",
            "permission": "view_payrolls",
            "enabled": false,
            "position": 4
          },
          {
            "title": "hr_insights",
            "icon": "bi-graph-up",
            "link": "/hr/insights",
            "permission": "view_hr_insights",
            "enabled": false,
            "position": 5
          }
        ]
      },
      {
        "module_key": "advanced_insights",
        "description": "advanced_insights_description",
        "title": "advanced_insights_title",
        "icon": "bi-graph-up-arrow",
        "position": 9,
        "enabled": false,
        "items": [
          {
            "title": "advanced_insights",
            "icon": "bi-graph-up-arrow",
            "link": "/advanced-insights",
            "permission": "view_advanced_insights",
            "enabled": false,
            "position": 1
          }
        ]
      },
      {
        "module_key": "contracts",
        "description": "contracts_description",
        "title": "contracts_title",
        "icon": "bi-file-earmark-text",
        "position": 9,
        "enabled": false,
        "items": [
          {
            "title": "contracts",
            "icon": "bi-file-earmark-text",
            "link": "/contracts",
            "permission": "view_contracts",
            "enabled": true,
            "position": 1
          }
        ]
      },
      {
        "module_key": "planning",
        "description": "planning_description",
        "title": "planning",
        "icon": "bi-calendar-check",
        "position": 11,
        "enabled": false,
        "items": [
          {
            "title": "plannings",
            "icon": "bi-calendar-event",
            "link": "/plannings",
            "permission": "view_plannings",
            "enabled": false,
            "position": 1
          },
          {
            "title": "my_planning",
            "icon": "bi-person-badge",
            "link": "/my-planning",
            "permission": "view_my_planning",
            "enabled": false,
            "position": 2
          }
        ]
      },
      {
        "module_key": "leads",
        "description": "leads_description",
        "title": "leads_title",
        "icon": "bi-person-lines-fill",
        "position": 10,
        "enabled": false,
        "items": [
          {
            "title": "leads",
            "icon": "bi-person-lines-fill",
            "link": "/leads",
            "permission": "view_leads",
            "enabled": false,
            "position": 1
          }
        ]
      },
      {
        "module_key": "ai",
        "description": "ai_description",
        "title": "ai_title",
        "icon": "bi-robot",
        "position": 13,
        "enabled": false,
        "items": [
          {
            "title": "gstocky_ai",
            "icon": "bi-robot",
            "link": "/ai",
            "permission": "view_ai",
            "enabled": false,
            "position": 1
          }
        ]
      },
      {
        "module_key": "marketing",
        "description": "marketing_description",
        "title": "marketing_title",
        "icon": "bi-megaphone",
        "position": 12,
        "enabled": false,
        "items": [
          {
            "title": "campaigns",
            "icon": "bi-megaphone",
            "link": "/marketing/campaigns",
            "permission": "view_marketing",
            "enabled": false,
            "position": 1
          },
          {
            "title": "segments",
            "icon": "bi-funnel",
            "link": "/marketing/segments",
            "permission": "view_marketing",
            "enabled": false,
            "position": 2
          }
        ]
      },
      {
        "module_key": "importer",
        "description": "importer_description",
        "title": "importer",
        "icon": "bi-file-earmark-arrow-up",
        "position": 14,
        "enabled": true,
        "items": [
          {
            "title": "importer",
            "icon": "bi-file-earmark-arrow-up",
            "link": "/importer",
            "permission": "view_importer",
            "enabled": true,
            "position": 1
          }
        ]
      },
      {
        "module_key": "settings",
        "description": "settings_description",
        "title": "settings_title",
        "icon": "bi-gear",
        "position": 10,
        "enabled": true,
        "items": [
          {
            "title": "settings",
            "icon": "bi-gear",
            "link": "/settings",
            "permission": "owner_only",
            "enabled": true,
            "position": 1
          }
        ]
      }
    ],
    user: {
      language: 'fr'
    },
    role: null,
    permissions: []
  },
  getters: {
    TOKEN: state => {
      return localStorage.getItem('access_token') ? localStorage.getItem('access_token') : state.token
    },
    BUSINESS: state => {
      return state.business;
    },
    MODULES: state => {
      const planKey = getBusinessPlanKey(state.business)
      const planModules = state.modules
        .filter(module => (
          module.module_key === 'settings' || canPlanAccessModule(planKey, module.module_key)
        ))
        .map(module => ({
          ...module,
          items: (module.items || []).filter(item => (
            module.module_key === 'settings' || canPlanAccessModuleItem(planKey, module.module_key, item.permission, item.title)
          ))
        }))

      // Do not expose modules while the current user's access is still loading.
      if (!state?.business?.id || !state.role) {
        return [];
      }

      // Owners can see every module allowed by the selected plan.
      if (state.role === 'owner') {
        return planModules;
      }

      // Admins and staff only see the plan-allowed modules assigned to them.
      return planModules.filter(module => {
        return module.items.some(item => {
          return state.permissions.includes(item.permission);
        });
      }).map(module => {
        return {
          ...module,
          items: module.items.filter(item => {
            return state.permissions.includes(item.permission);
          })
        };
      });
    },
    USER: state => {
      return state.user;
    },
    ROLE: state => {
      return state.role;
    },
    PERMISSIONS: state => {
      return state.permissions;
    },
    NAV_FULL_SIZE: state => {
      return state.navFullSize;
    },
    KIOSK_MODE: state => {
      return state.kioskMode;
    },
    FREE_TRIALS: state => {
      return state.business.free_trials;
    },
    HAS_PERMISSION_AND_MODULE_ENABLED: (state) => (permission) => {
      // Find the module that contains the item with the given permission
      const module = state.modules.find(mod =>
        mod.items.some(item => item.permission === permission)
      );
      if (!module) return false;
      const planKey = getBusinessPlanKey(state.business)
      if (module.module_key !== 'settings' && !canPlanAccessModule(planKey, module.module_key)) return false
      const item = (module.items || []).find(item => item.permission === permission)
      if (module.module_key !== 'settings' && !canPlanAccessModuleItem(planKey, module.module_key, permission, item?.title)) return false
      // Only the business owner bypasses explicitly assigned permissions.
      const hasPermission = state.role === 'owner' || state.permissions.includes(permission)
      return module.enabled && hasPermission;
    },
  },
  mutations: {
    SET_BUSINESS: (state, business) => {
      const businessClone = JSON.parse(JSON.stringify(business))
      businessClone.metadata = businessClone.metadata || {}
      const planKey = getBusinessPlanKey(businessClone)
      businessClone.plan_id = planKey || DEFAULT_PLAN_KEY
      businessClone.metadata.plan_key = businessClone.plan_id
      businessClone.price_includes_tax = businessClone?.metadata?.price_includes_tax != undefined ? businessClone?.metadata?.price_includes_tax : false

      // If user is account manager, remove affiliate_id from business
      const accountManagerId = localStorage.getItem('account_manager_id')
      if (accountManagerId && accountManagerId == businessClone.affiliate_id) {
        businessClone.affiliate_id = null
      }
      state.business = businessClone

      const currentLang = localStorage.getItem('currentLang')
      if (currentLang) {
        state.business.language = currentLang
      }
      if (business.currency) {
        localStorage.setItem('currentCurrency', business.currency)
      }


      window.Bugsnag.setUser(business.id, business.email, business.name)
    },
    SET_USER: (state, user) => {
      if (user.language) {
        state.business.language = user.language
        localStorage.setItem('currentLang', user.language)
      }
      state.user = user
    },
    SET_TOKEN: (state, token) => {
      localStorage.setItem('access_token', token)
      state.token = token
    },
    SET_REFRESH_TOKEN: (state, token) => {
      localStorage.setItem('refresh_token', token)
    },
    SET_MODULES: (state, modules) => {
      // Merge modules from database with store modules
      for (let i = 0; i < state.modules.length; i++) {
        const storeModule = state.modules[i]
        const dbModule = modules.find(m => m.module_key === storeModule.module_key)

        if (!dbModule) {
          // Module doesn't exist in DB, add the entire store module
          modules.push(storeModule)
        } else {
          // Module exists in DB, merge items from store that don't exist in DB
          for (let j = 0; j < storeModule.items.length; j++) {
            const storeItem = storeModule.items[j]
            const dbItem = dbModule.items.find(item => item.link === storeItem.link)

            if (!dbItem) {
              // Item doesn't exist in DB module, add it
              dbModule.items.push(storeItem)
            }
          }

          // Keep HR menu aligned with current product surface and permission keys.
          if (storeModule.module_key === 'hr') {
            dbModule.items = dbModule.items
              .filter(item => item.link !== '/hr/documents')
              .map(item => {
                if (item.link === '/hr/my-space') return { ...item, permission: 'view_my_space' }
                if (item.link === '/hr/leaves') return { ...item, permission: 'view_holidays' }
                if (item.link === '/hr/attendance') return { ...item, permission: 'view_attendances' }
                if (item.link === '/hr/payroll') return { ...item, permission: 'view_payrolls' }
                return item
              })
          }

          // Receipts have their own permission even when an existing business
          // still has the legacy invoice permission stored for this menu item.
          if (storeModule.module_key === 'sales') {
            dbModule.items = dbModule.items.map(item => (
              item.link === '/receipts' ? { ...item, permission: 'view_receipts' } : item
            ))
          }

          // Replace the original single marketing link with Campaigns and Segments.
          if (storeModule.module_key === 'marketing') {
            dbModule.items = dbModule.items.filter(item => item.link !== '/marketing')
          }
        }
      }
      state.modules = modules
    },
    SET_PERMISSIONS: (state, data) => {
      state.permissions = Array.isArray(data?.permissions) ? data.permissions : []
      state.role = ['owner', 'admin', 'staff'].includes(data?.role) ? data.role : null
    },
    SET_NAV_FULL_SIZE: (state, data) => {
      localStorage.setItem('navFullSize', data)
      state.navFullSize = data
    },
    SET_KIOSK_MODE: (state, data) => {
      state.kioskMode = data
    }
  },
})
